import { useState } from 'react';

import { InferComponentProps } from '@cast/shared-types';

import { useDrawer } from './useDrawer';
import { DrawerProps, OpenDrawerArgs, ValidDrawerComponent } from '../types';

export const useDrawerWithProps = <T extends object>() => {
  const [openedDrawerId, setOpenedDrawerId] = useState<string | undefined>();
  const { open: openDrawer, drawers } = useDrawer();

  return {
    open: <
      COMPONENT extends ValidDrawerComponent,
      PROPS = InferComponentProps<COMPONENT>
    >(
      args: OpenDrawerArgs<COMPONENT, PROPS>
    ) => {
      const drawer = openDrawer(args);
      setOpenedDrawerId(drawer.id);
      return drawer;
    },
    drawerProps: openedDrawerId
      ? (drawers[openedDrawerId]?.props as DrawerProps & T)
      : undefined,
  };
};
